import { ModelFactory } from '@shared/factories/model.factory';
import { UserType } from '@generated/graphql';
import { User } from '@modules/user/models/user.model';

export class UserFactory extends ModelFactory<UserType, User> {
  create (state: UserType): User {
    return new User(state);
  }
}

export const userFactory = new UserFactory();
